export default __webpack_public_path__ + "static/media/blog-g-3.cac8b771.png";